export class Location {
  public constructor(public lat: number, public lng: number) {}
}
